import { observable, decorate, action } from "mobx"
import autoBind from "auto-bind"
class ChatTaskStore {

  tasks = [];
  currentTaskIndex = -1;

  packs
  sheets
  subsheets
  fieldsByType = {}
  emails = []
  roles = []
  sheetIds = []

  constructor() {
    // super();
    autoBind(this)
    this.reset();
  }

  front() { }
  enqueue() { }
  dequeue() { }
  isEmpty() { }
  size() { }

  // new fns
  reset() {
    this.tasks = []
    this.currentTaskIndex = -1;
    //
    this.packs = []
    this.sheets = [];
    this.subsheets = [];
    this.newSheetNames = {};
    this.emails = [];
    this.roles = [];
    this.sheetIds = [];
    this.fieldsByType = {}
  }

  setTasks(tasks) {
    this.tasks = tasks;
  }

  addTask(task) {
    this.tasks.push(task)
  }

  updateTaskIndex(index) {
    this.currentTaskIndex = index;
  }

  moveToNextTask() {
    this.currentTaskIndex++;
  }

  moveToPrevTask() {
    this.currentTaskIndex--;
  }

  updateTaskData(data, index) {
    if (!this.tasks[index]) return;
    this.tasks[index].data = data
  }

  setEmails(emails) {
    this.emails = emails
  }

  setRoles(roles) {
    this.roles = roles
  }

  setSheetIds(ids) {
    this.sheetIds = ids
  }

  setPacks(packs) {
    this.packs = packs
  }

  setSheets(sheets) {
    this.sheets = sheets
  }

  setSubsheets(subsheets) {
    this.subsheets = subsheets
  }

  setSheetsNewNames(newSheetNames) {
    this.newSheetNames = newSheetNames
  }

  setFields(fields, fieldType) {
    this.fieldsByType[fieldType] = fields;
  }

  addFields(fields, fieldType) {
    if (!this.fieldsByType[fieldType])
      this.fieldsByType[fieldType] = [];

    this.fieldsByType[fieldType].push(...fields)

  }

}

decorate(ChatTaskStore, {
  // head: observable,
  // tail: observable,
  // map: observable,

  enqueue: action,
  dequeue: action,

  front: action,
  isEmpty: action,
  size: action,

  //
  tasks: observable,
  currentTaskIndex: observable,

  packs: observable,
  sheets: observable,
  subsheets: observable,
  newSheetNames: observable,
  fieldsByType: observable,


  setTasks: action,
  addTask: action,
  updateTaskData: action,
  updateTaskIndex: action,
  reset: action,
  moveToNextTask: action,
  moveToPrevTask: action,
  setPacks: action,
  setSheets: action,
  setSubsheets: action,
  setFields: action,
  addFields: action,
  setSheetsNewNames: action
})

export default ChatTaskStore;